<script>

import SearchResult from './SearchResult.svelte'
import { searchResultPageNumber, searchResultSortOrder, updateQueryString } from './urlParams.js'

export let searchResults
export let timings

const searchResultPageSize = 20

$: start = $searchResultPageNumber * searchResultPageSize
$: end = $searchResultPageNumber * searchResultPageSize + searchResultPageSize - 1
$: searchSlice = searchResults.slice(start, end)

$: if ($searchResultSortOrder === 'chronological') {
  searchResults = searchResults.sort(function (a, b) {
    const aReference = a.ref.split('_')
    const bReference = b.ref.split('_')
    if (aReference[0] == bReference[0]) {
      return (parseInt(aReference[1]) - parseInt(bReference[1]))
    } else {
      return aReference[0].localeCompare(bReference[0])
    }
  })
}

function handleNextClick () {
  if (end < searchResults.length) {
    searchResultPageNumber.update(n => n + 1)
    window.scrollTo(0, 0)
    updateQueryString()
  }
}

function handlePreviousClick () {
  if ($searchResultPageNumber <= 0) {
    searchResultPageNumber.set(0)
  } else {
    searchResultPageNumber.update(n => n - 1)
    window.scrollTo(0, 0)
    updateQueryString()
  }
}
</script>

{#if searchResults.length > 0}
	{#each searchSlice as result, i (result.ref)}
		<SearchResult result={result} timings={timings} elementNumber={i}/>
	{/each}
	{#if searchResults.length > searchResultPageSize}
		<button on:click={handlePreviousClick}>Previous</button>
		<button on:click={handleNextClick}>Next</button>
	{/if}
	<p>{start+1} to {searchResults.length >= end ? end+1: searchResults.length} of {searchResults.length}</p>
{:else}
<p>No Results Found</p>
<p>Sometimes the search engine throws out trivial words (like "you and me")...</p>
{/if}